// extracted by mini-css-extract-plugin
export default {"companylinkedinStylecolourIcon":"CompanyLinkedInStyleColourIcon_companylinkedinStylecolourIcon__EJDI2"};